import { take, fork, put, call, select } from 'redux-saga/effects';
import { callApi } from './callApi';
import actionTypes from '../actionTypes';
import { getCurrentAccount } from '../../store/selectors';
import { successTournamentGameUrl, failTournamentGameUrl } from '../actionCreators/tournamentGameUrls';
import { isMobile } from 'react-device-detect';
import config from '../../config/config';

const providersWithUniversalHome = ['PragmaticPlay'];

function* getTournamentGameUrl({game}) {
  let tournamentGame = game.tournamentGames[0];
  console.log('game = ', game);
  try {
    const { id: userId, token } = yield select(getCurrentAccount);
    const params = {
      userId,
      token,
      id: tournamentGame["id"],
      providerName: tournamentGame["providerName"],
      integrator: tournamentGame["integrator"],
      lang: localStorage.language,
      device:  isMobile ? 'mobile' : 'desktop',
      tournamentId: game.tournamentId,
    };
    if( game.integrator === 'silver' ) {
      params.lobbyUrl = config.SILVER_HOME_URL;
    } else if( isMobile || ['Habanero', 'Endorphina'].includes(game.provider) ) {
      params.lobbyUrl = window.location.origin.toString();
    } else if ( isMobile || providersWithUniversalHome.includes(game.provider) ) {
	    params.lobbyUrl = config.UNIVERSAL_HOME_URL;
    }

    const response = yield call(callApi, `${config.API_TOURNAMENT_URL}/tour/getCasinoUrlForTournament`, 'GET', params);
    console.log('response = ', response);
    yield put(successTournamentGameUrl(game.tournamentId, response.data.result.data.url, response.data.result.data.width));
  } catch (e) {
    yield put(failTournamentGameUrl(game.tournamentId, e));
  }
}

export function* watchRequestTournamentGameUrl() {
  while (true) {
    const action = yield take(actionTypes.TOURNAMENT_GAME_URL_REQUEST);
    yield fork(getTournamentGameUrl, action.value);
  }
}